import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createRoadtrip } from '../services/api';

const NewRoadtrip = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    status: '1',
    gpxFiles: [],
    dates: []
  });
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await createRoadtrip(formData);
      if (response.success) {
        navigate(`/roadtrip/${response.data.roadtrip_id}`);
      } else {
        setError(response.message || 'Erreur lors de la création du roadtrip');
      }
    } catch (err) {
      console.error('Erreur handleSubmit:', err);
      setError('Erreur lors de la création du roadtrip');
    }
  };

  return (
    <div className="new-roadtrip-container">
      <h2>Nouveau Roadtrip</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="step-one">
          <div className="form-group">
            <label>Nom du roadtrip</label>
            <input
              type="text"
              className="form-control"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
            />
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              className="form-control"
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
            />
          </div>

          <div className="form-group">
            <label>Statut</label>
            <select
              className="form-control"
              value={formData.status}
              onChange={(e) => setFormData({...formData, status: e.target.value})}
            >
              <option value="1">Déjà fait</option>
              <option value="2">À faire</option>
            </select>
          </div>
        </div>
        <div className="buttons-container">
          <button type="submit" className="btn btn-primary">Créer le roadtrip</button>
        </div>
      </form>
    </div>
  );
};

export default NewRoadtrip; 